import { atom } from "jotai";

import { currentBookingAtom } from "../../stores";

export const setOwnerAtom = atom(
  null,
  (get, set, payload: { roundId: string }) => {
    const booking = get(currentBookingAtom);
    if (!booking) return;

    const roundExists = booking.rounds.some(
      (round) => round.localId === payload.roundId
    );
    if (!roundExists) return;

    const updatedRounds = booking.rounds.map((round) => ({
      ...round,
      isOwner: round.localId === payload.roundId && !!round.player.id,
    }));

    set(currentBookingAtom, {
      ...booking,
      rounds: updatedRounds,
    });
  }
);
